import { Button, Divider, Stack, styled, Text } from '@ltvco/refresh-lib/theme';
import { AuthRequiredModal } from '@ltvco/refresh-lib/v2';
import { AccountCircle } from '@mui/icons-material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const StyledButton = styled(Button)({
  height: 'fit-content',
  textTransform: 'none',
  whiteSpace: 'nowrap',

  '&:hover': {
    backgroundColor: 'transparent',
  },
});

const SUBSCRIBE_URL = 'https://www.bumper.com/lp/8b3bc4/4/subscribe';

export const SignInButton = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (): void => setIsModalOpen(true);
  const closeModal = (): void => setIsModalOpen(false);
  const goToLogin = (): void => {
    closeModal();
    navigate('/login');
  };
  const goToSignup = (): void => window.location.assign(SUBSCRIBE_URL);

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        width="100%"
        height="100%"
      >
        <Divider orientation="vertical" flexItem sx={{ my: 1.5 }} />
        <StyledButton
          disableRipple
          onClick={openModal}
          data-testid="header-sign-in-button"
        >
          <Stack direction="row" alignItems="center" spacing={0.75}>
            <AccountCircle sx={{ color: '#212121' }} />
            <Text fontWeight={700}>Sign Up / Sign In</Text>
          </Stack>
        </StyledButton>
      </Stack>
      <AuthRequiredModal
        open={isModalOpen}
        onClose={closeModal}
        onLogin={goToLogin}
        onSignup={goToSignup}
      />
    </>
  );
};
